// Valis
import Valis from '../../util/Valis';
import * as components from '../../components';
import gsap from 'gsap';
import state from '../../state';
import { q1O } from '../../util/nE';

const defaultTransition = {
  name: 'default',
  // sync: true,

  leave(data) {
    const done = this.async();
    const tl = gsap.timeline({
      onComplete: () => {
        state.valis.destroyComponents();
        state.valis = null;
        state.smoothScroll.destroy();
        done();
      },
    });

    tl.to(data.current.container, {
      autoAlpha: 0,
      duration: 0.5,
      ease: t => {
        return q1O(t);
      },
    });

    return tl;
  },
  beforeEnter: ({ next }) => {
    const bodyClasses = next.container.getAttribute('data-body-classes');
    document.body.setAttribute('class', bodyClasses);
  },
  enter: data => {
    const componentElements = gsap.utils.toArray(
      data.next.container.querySelectorAll('[data-component]')
    );
    state.valis = new Valis();
    // window.scrollTo(0, 0)

    const enterTl = gsap.timeline({
      onComplete: () => {
        document.querySelector('html').classList.remove('block-ui');
        state.valis.initComponents(components, componentElements);
      },
    });

    enterTl.fromTo(
      data.next.container,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        duration: 0.5,
        ease: t => {
          return q1O(t);
        },
      }
    );
  },
};
export default defaultTransition;



//////////////////
// WEBPACK FOOTER
// ./scripts/barba/transitions/default.js
// module id = 22
// module chunks = 0